<template lang="pug">
  .payments
    FiltrableTable
      template(v-slot="{ bus }")
        payments-list-table(
          :bus="bus"
          :payments="payments"
          :currency="currency"
        )
</template>

<script>
import FiltrableTable from '@/components/FilterableTable/FilterableTable.vue';
import PaymentsListTable from './PaymentsListTable.vue';

export default {
  name: 'PaymentsList',
  props: {
    payments: {
      type: Array,
      required: true
    },
    currency: {
      type: String,
      default: 'руб.'
    }
  },

  components: {
    FiltrableTable,
    PaymentsListTable
  }
};
</script>
